var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeactiveNextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6664 0H1.66665C0.749989 0 0 0.74999 0 1.66664V18.3331C0 19.2497 0.749989 19.9997 1.66665 19.9997H21.6664C22.583 19.9997 23.333 19.2497 23.333 18.3331V1.66664C23.333 0.74999 22.583 0 21.6664 0ZM21.6664 18.3331H8.33322V10.8332H16.8331L13.8331 13.8331L14.9998 14.9998L19.9997 9.99986L14.9998 4.99993L13.8331 6.16658L16.8331 9.16654H8.33322V1.66664H21.6664V18.3331Z",
    fill: "#F2F3F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactiveNextIcon);
export default __webpack_public_path__ + "static/media/DeactiveNextIcon.365199a218ba696463bbf31189a9e2b3.svg";
export { ForwardRef as ReactComponent };